import { useNavigate } from 'react-router'
import { Button } from '@/ui'

/**
 * "← Back" for client pages reached from somewhere else in the portal (People, Galleries). Goes to the
 * previous screen when there is one in this tab's history; otherwise to `fallback`, e.g. the onboarding.
 */
export function BackLink({ fallback, label = 'Back' }: { fallback: string; label?: string }) {
  const navigate = useNavigate()
  const canGoBack = typeof window !== 'undefined' && ((window.history.state as { idx?: number } | null)?.idx ?? 0) > 0
  return (
    <Button variant="link" size="sm" arrow={false} onClick={() => (canGoBack ? navigate(-1) : navigate(fallback))}>
      ← {label}
    </Button>
  )
}
